import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./PageShopCategories.css";
import { CATEGORY_API, IMAGE_BASE_URL } from "../components/apiurls";

function PageShopCategories() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const siteId = searchParams.get("site_id");
  const shopName = searchParams.get("shop_name");
  const shopAddress = searchParams.get("shop_address");

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------- FETCH CATEGORIES ---------- */

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);

        const response = await fetch(CATEGORY_API);

        console.log("Category API Status:", response.status);

        const data = await response.json();

        console.log("Category API Response:", data);

        if (Array.isArray(data)) {
          setCategories(data);
        } else {
          setCategories([]);
          console.error("Category API did not return an array");
        }
      } catch (error) {
        console.error("Category API Error:", error);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  /* ---------- OPEN CATEGORY ---------- */

  const openCategory = (category) => {
    navigate(
      `/shop-products?site_id=${siteId}&cat_id=${category.cat_id}&shop_name=${encodeURIComponent(
        shopName
      )}&shop_address=${encodeURIComponent(
        shopAddress || ""
      )}&category_name=${encodeURIComponent(category.cat_name)}`
    );
  };

  /* ---------- LOADING ---------- */

  if (loading) {
    return (
      <div className="page-shop-categories">
        <div className="shop-header">
        <h2 className="shop-name">{shopName}</h2>

        {shopAddress && (
          <p className="shop-address">
            📍 {shopAddress}
          </p>
        )}
      </div>

        <div className="category-loading">
          Loading Categories...
        </div>
      </div>
    );
  }

  /* ---------- UI ---------- */

  return (
    <div className="page-shop-categories">

      <div className="shop-header">
        <h2 className="shop-name">
          {shopName}
        </h2>

        {shopAddress && (
          <p className="shop-address">
            📍 {shopAddress}
          </p>
        )}
      </div>

      <div className="category-grid">

        {categories.length === 0 ? (
          <div className="no-categories">
            No Categories Found
          </div>
        ) : (
          categories.map((category) => (

            <div
              key={category.cat_id}
              className="category-card"
              onClick={() => openCategory(category)}
            >

              <div className="category-image">
                <img
                  src={`${IMAGE_BASE_URL}${category.thumb}`}
                  alt={category.cat_name}
                  onError={(e) => {
                    console.error(
                      "Category image failed:",
                      `${IMAGE_BASE_URL}${category.thumb}`
                    );
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>

              <div className="category-title">
                {category.cat_name}
              </div>

            </div>

          ))
        )}

      </div>

    </div>
  );
}

export default PageShopCategories;